import React from 'react';

const ApprovedSheetsEmployee = () => {
    return (
        <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Do I get notified when my timesheet is approved?
            </h3>
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                This section displays all the timesheets that have been approved by the approval manager and the super admin.
                Only the records that have passed through the entire approval process are visible here for tracking and review.
            </p>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Approved Sheets</h4>
            
            <img
                style={{ width: "60%", borderRadius: "8px", marginTop: "10px" }}
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352875/Approved_sheets-1_e1w0sw.png"
                alt="Employee Table Screenshot"
            />
            
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", marginTop: "10px" }}>
                The above section provides a detailed summary of all approved timesheets, including the approval status and any comments provided by the approvers.
            </p>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>How to Check Your Approved Timesheet?</h4>
            <ol style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li>Step 1: Click on Sheets and select the Approved Sheets section.</li>
                <li>Step 2: Choose the timesheet you want to check for approval details.</li>
            </ol>
            
            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Important Notes:</h4>
            <ul style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li>If an employee submits their timesheet, it must be approved or rejected by the Super Admin or Approval Manager.</li>
                <li>If your timesheet is approved, you will receive an email and notification. Your approved sheet will then be visible in the Approved Sheets section.</li>
            </ul>
            
            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#444", marginTop: "20px" }}>Tip:</h4>
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                If your timesheet has been rejected, it will be listed in the Rejected Sheets section.
                You can resubmit your timesheet from there for approval again.
            </p>
        </div>
    );
};

export default ApprovedSheetsEmployee;
